<template>
  <div>
    <div v-if="transfer">
      <div v-if="logo" v-images-loaded="loaded" class="has-text-centered">
        <img :src="require('@/assets/' + logo)" alt="Logo" style="height: 75px;">
      </div>

      <h5 class="title is-5 has-text-centered">
        T.C.
        <br>
        {{ panelCompanyName }}
        <br>
        Taşıt Görev Formu
      </h5>

      <p class="is-size-7 has-text-right">
        <span class="has-text-weight-semibold">Tarih:</span> {{ today }}
      </p>

      <h6 class="title is-6 has-text-centered mb-2">Taşıt Görev Bilgileri</h6>
      <table class="table is-bordered is-fullwidth is-narrow">
        <tbody>
          <tr>
            <td class="has-text-weight-semibold col-4">ID:</td>
            <td>#{{ transfer.id }}</td>
          </tr>
          <tr>
            <td class="has-text-weight-semibold col-4">Durum:</td>
            <td>{{ $t(`status.${transfer.status}`) }}</td>
          </tr>
          <tr>
            <td class="has-text-weight-semibold col-4">Kalkış Adres:</td>
            <td>{{ fromAddress }}</td>
          </tr>
          <tr>
            <td class="has-text-weight-semibold col-4">Varış Adres:</td>
            <td>{{ toAddress }}</td>
          </tr>
          <tr>
            <td class="has-text-weight-semibold col-4">Görev Zamanı:</td>
            <td>{{ transfer.transfer_date | formatDate }}</td>
          </tr>
          <tr>
            <td class="has-text-weight-semibold col-4">Görev Türü:</td>
            <td>{{ transfer.duty_type_specification.name }}</td>
          </tr>
          <tr>
            <td class="has-text-weight-semibold col-4">Araç Türü:</td>
            <td>{{ transfer.vehicle_type_specification.name }}</td>
          </tr>
          <tr>
            <td class="has-text-weight-semibold col-4">Talep Eden Birim:</td>
            <td>{{ transfer.request_unit_specification.name }}</td>
          </tr>
          <tr>
            <td class="has-text-weight-semibold col-4">Talep Eden Ad & Soyad:</td>
            <td>{{ transfer.demandant_name }}</td>
          </tr>
          <tr>
            <td class="has-text-weight-semibold col-4">Talep Eden Telefon:</td>
            <td>{{ transfer.demandant_phone }}</td>
          </tr>
        </tbody>
      </table>

      <h6 class="title is-6 has-text-centered mb-2">Sürücü & Araç Bilgileri</h6>
      <table class="table is-bordered is-fullwidth is-narrow">
        <tbody>
          <tr v-if="transfer.driver">
            <td class="has-text-weight-semibold col-4">Sürücü Ad & Soyad:</td>
            <td>{{ transfer.driver.name }}</td>
          </tr>
          <tr v-if="transfer.driver">
            <td class="has-text-weight-semibold col-4">Sürücü Telefon:</td>
            <td>{{ transfer.driver.phone }}</td>
          </tr>
          <tr v-if="transfer.car">
            <td class="has-text-weight-semibold col-4">Plaka:</td>
            <td>{{ transfer.car.plate }}</td>
          </tr>
          <tr v-if="transfer.car">
            <td class="has-text-weight-semibold col-4">Marka:</td>
            <td>{{ transfer.car.brand }}</td>
          </tr>
          <tr v-if="transfer.car">
            <td class="has-text-weight-semibold col-4">Model:</td>
            <td>{{ transfer.car.model }}</td>
          </tr>
          <tr v-if="transfer.car">
            <td class="has-text-weight-semibold col-4">Koltuk Sayısı:</td>
            <td>{{ transfer.car.number_of_seats }}</td>
          </tr>
          <tr>
            <td class="has-text-weight-semibold col-4">Başlangıç KM:</td>
            <td>{{ transfer.start_km }}</td>
          </tr>
          <tr>
            <td class="has-text-weight-semibold col-4">Bitiş KM:</td>
            <td>{{ transfer.end_km }}</td>
          </tr>
        </tbody>
      </table>
      <div class="is-flex is-justify-content-space-between">
        <p class="signature has-text-black mb-4">Onaylayan</p>
        <p class="signature has-text-black">Sürücü</p>
      </div>
    </div>
    <div v-else class="has-text-centered my-4">
      Yazdırılıyor...
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'
import imagesLoaded from 'vue-images-loaded'

export default {
  directives: {
    imagesLoaded
  },
  data () {
    return {
      transfer: null
    }
  },
  computed: {
    ...mapState([
      'panelCompanyName',
    ]),
    ...mapGetters([
      'logo',
    ]),
    today () {
      return moment().format('DD.MM.YYYY')
    },
    fromAddress () {
      return this.transfer.from_neighborhood.name + ' mah. ' + this.transfer.from_address_line + ', ' + this.transfer.from_district.name + ' / ' + this.transfer.from_province.name
    },
    toAddress () {
      return this.transfer.to_neighborhood.name + ' mah. ' + this.transfer.to_address_line + ', ' + this.transfer.to_district.name + ' / ' + this.transfer.to_province.name
    },
  },
  mounted () {
    this.getTransfer(this.$route.params.id).then(({ data }) => {
      this.transfer = data.data
    })
  },
  methods: {
    getTransfer (transferId) {
      return this.$http.get(`transfers/${transferId}`)
    },
    loaded () {
      this.transfer && window.print()
    }
  },
  beforeRouteEnter (to, from, next) {
    if (/^(?!0)\d+$/gmi.test(to.params.id)) {
      next()
    } else {
      next({ name: 'transfers.index' })
    }
  }
}
</script>

<style>
.section {
  padding: 1rem;
}
.hero-body {
  padding: 0;
}
.hero.is-fullheight .hero-body {
  align-items: flex-start;
}
.column.is-two-fifths {
  width: 100%;
}
table > tbody > tr > td,
.signature {
  font-size: .8em;
}
.col-4 {
  width: 33.333333%;
}
.is-justify-content-space-between {
  justify-content: space-between;
}
@media print {
  @page { size: portrait }
}
</style>